import type {
  CarrotPlanFormOption,
  MediaOptionFields,
  MenuItemOptionFields,
  TopicOptionFields
} from "./hooks/useCarrotPlanMappings"

export enum CarrotPlanErrorMessage {
  NEEDS_JOURNEY_OR_PHASE = "Please select a different primary journey and phase for the member.",
  NEEDS_STEP = "At least one step is required"
}

export type CarrotPlanFormStep = {
  id: string
  stepIndex: number
  menuItem?: CarrotPlanFormOption<MenuItemOptionFields>
  topic?: CarrotPlanFormOption<TopicOptionFields>
  content?: CarrotPlanFormOption<MediaOptionFields>
  url?: string | null
}

export type UnslottedStep = Omit<CarrotPlanFormStep, "id" | "stepIndex">

export enum FieldName {
  steps = "steps",
  menuItem = "menuItem",
  topic = "topic",
  content = "content",
  url = "url",
  primaryJourney = "primaryJourney",
  primaryJourneyPhase = "primaryJourneyPhase",
  secondaryJourney = "secondaryJourney",
  secondaryJourneyPhase = "secondaryJourneyPhase",
  tertiaryJourney = "tertiaryJourney",
  tertiaryJourneyPhase = "tertiaryJourneyPhase"
}

export type CarrotPlanFormProps = {
  steps: CarrotPlanFormStep[]
  primaryJourney: number
  primaryJourneyPhase: number
  secondaryJourney: number
  secondaryJourneyPhase: number
  tertiaryJourney: number
  tertiaryJourneyPhase: number
}
